import { AfterViewInit, Component, ElementRef, Input, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DTO } from '../../../app/core/models/dto';
import { PromotionLeaderboardService } from '../../core/service/promotion-leaderboard.service';
import { CommonService } from '../../core/service/common.service';
import { MyInfo, PrizePoolList, RankingPlayerList } from '../../core/interface/leaderboard.interface';
import { environment } from '../../../environments/environment';
import { CashPipe } from '../../shared/pipes/cash.pipe';

@Component({
    selector: 'app-promotion-leaderboard-list-table',
    templateUrl: 'promotion-leaderboard-list-table.component.html',
    styleUrls: ['promotion-leaderboard-list-table.component.scss']
})
export class PromotionLeaderboardListTableComponent implements AfterViewInit {
    @Input() public progress: boolean;
    @Input() public isMaintenance: boolean;
    @Input() public isScrolling: boolean;
    @Input() public myInfo: MyInfo;
    @Input() public promotionId: number;
    @Input() public type: DTO.Enums.PromotionType;
    @Input() public nickname: string;
    @Input() public brandId: string;
    @Input() public siteId: string;
    @Input() public playerLimit: number;
    @Input() public prizeVisibility: boolean;
    @Input() public prizePoolList: PrizePoolList[];
    @Input() public rankingList: RankingPlayerList[];
    @Input() public countryCodes: { [key: string]: string } = {};
    @Input() public onlyCoin: boolean;
    @Input() public hideSymbol: boolean;
    @Input() public hideCustomSymbol: boolean;
    @Input() public countryCode: string;
    @Input() public focusFirstPlayer: boolean;
    @Input() public isBountyKOPromotion?: boolean;
    @ViewChildren('ranks') myRankMarking: QueryList<ElementRef>;
    @ViewChildren('runningPrizeLevel') runningPrizeLevelMarking: QueryList<ElementRef>;
    private cashPipe = new CashPipe('en');
    public isRefreshable = true;
    private environment = environment.env;
    private wsopPrizeCustomList = {
        PROD: [43692],
        TEST: [27406]
    };

    public checkSameUser(player: any) {
        let ret = false;
        if (this.brandId && this.siteId) {
            ret = player.nickname === this.parsedNickname && player.brandId.toUpperCase() === this.brandId.toUpperCase() && player.siteId.toUpperCase() === this.siteId.toUpperCase();
        } else if (this.brandId && !this.siteId) {
            ret = player.nickname === this.parsedNickname && player.brandId.toUpperCase() === this.brandId.toUpperCase();
        }
        return ret;
    }

    public get isIndiaCountry() {
        return this.countryCode === 'IN';
    }

    public get parsedNickname() {
        try {
            return atob(decodeURIComponent(this.nickname)).replace(/^YouCanSeeMe(.+)DoNotThis$/, '$1');
        } catch (e) {
            return '';
        }
    }

    public get isWsopPrizeCustom() {
        const env = this.environment !== 'PROD' ? 'TEST' : this.environment;
        return this.wsopPrizeCustomList[env].indexOf(Number(this.promotionId)) > -1;
    }

    public get isChase() {
        return [DTO.Enums.PromotionType.CHASE, DTO.Enums.PromotionType.TOURNAMENT_LEADERBOARD_CHASE].indexOf(this.type) !== -1;
    }

    public get isTournamentLeaderBoard() {
        return this.type === DTO.Enums.PromotionType.TOURNAMENT_LEADERBOARD;
    }

    constructor(
        private route: ActivatedRoute,
        private leaderboardService: PromotionLeaderboardService,
        private commonService: CommonService) {
    }

    public ngAfterViewInit() {
        this.listScrollToView(this.myRankMarking);
        this.listScrollToView(this.runningPrizeLevelMarking);
    }

    private listScrollToView(scrollTargetElements: QueryList<ElementRef>) {
        scrollTargetElements.changes.subscribe(() => {
            scrollTargetElements.toArray().forEach(el => {
                if (el.nativeElement.classList.contains('myRank')) {
                    el.nativeElement.scrollIntoView({ behavior: 'smooth' });
                }
            });
        });
    }

    public getCountry(countryCode: string) {
        return (this.countryCodes && this.countryCodes.hasOwnProperty(countryCode)) ? this.countryCodes[countryCode] : countryCode;
    }

    public wsopPrizeCustom(data) {
        let prize;
        const prizeITems = [];
        if (data.prizeItem) {
            data.prizeItem.map(item => {
                switch (item.currencyId) {
                    case 'GTD':
                        prizeITems.push(
                            this.cashPipe.transform(item.value, item.currencyId, 'symbol-narrow', '1.0-2')
                        );
                        break;
                    default:
                        const description = JSON.parse(item.description);
                        prizeITems.push(
                            `${description.name} x ${item.quantity}`
                        );
                        break;
                }
            });
            prize = `(${prizeITems.join('+')})`;
        }
        return prize;
    }
}
